export const COMFORT = "#d97f33";
export const ECO = "#5C9DAD";
export const ON = "#579458";
export const REGULATED = "#ab5b9f";
export const SECURED = "#c7514c";